import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session lives in an httpOnly cookie — just ask the server who we are.
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const loginWith = (userData) => setUser(userData);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // cookie clear failed server-side; still drop the client session
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginWith, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
